// client/src/api/api.js - Configuration Axios
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://food.api.j7lab.com',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Ajout d'un intercepteur requête pour taguer le type d'action (Realtime admin)
api.interceptors.request.use((config) => {
  try {
    const url = (config.url || '').toString();
    const method = (config.method || 'get').toLowerCase();
    const setHeader = (val) => { if (!config.headers['X-Activity-Type']) config.headers['X-Activity-Type'] = val; };

    if (url.includes('/api/users/login')) setHeader('LOGIN');
    else if (url.includes('/api/users/register')) setHeader('REGISTER');
    else if (url.includes('/api/users/profile')) setHeader(method === 'get' ? 'PROFILE_VIEW' : 'PROFILE_UPDATE');
    else if (url.includes('/api/stripe/checkout-session')) setHeader('SUBSCRIPTION_CHECKOUT');
    else if (url.includes('/api/stripe/portal-session')) setHeader('SUBSCRIPTION_PORTAL');
    else if (url.includes('/api/stripe/create-subscription')) setHeader('SUBSCRIPTION_CREATE');
    else if (url.includes('/api/stripe/sync-subscription')) setHeader('SUBSCRIPTION_SYNC');
    else if (url.includes('/api/stripe/cancel-subscription')) setHeader('SUBSCRIPTION_CANCEL');
    else if (url.includes('/api/stripe/resume-subscription')) setHeader('SUBSCRIPTION_RESUME');
    else if (url.includes('/api/meals/recipe-suggestions') || url.includes('/api/meals/suggestions')) setHeader('SUGGESTIONS_FETCH');
    else if (url.includes('/api/meals/generate-recipe')) setHeader('RECIPE_CREATE');
    else if (url.includes('/api/meals/iterate-recipe')) setHeader('RECIPE_ITERATE');
    else if (url.includes('/api/meals/question-about-recipe')) setHeader('RECIPE_QUESTION');
    else if (url.includes('/api/meals/transform-suggestion-to-recipe')) setHeader('SUGGESTION_TO_RECIPE');
    else if (url.includes('/api/meals/recipe/')) setHeader('RECIPE_VIEW');
    else if (url.includes('/api/meals/recipes')) setHeader('RECIPES_LIST');
    else if (url.match(/\/api\/meals(\/|$)/)) {
      if (method === 'post') setHeader('MEALPLAN_CREATE');
      else if (method === 'get') setHeader('MEALPLAN_LIST');
      else if (method === 'put') setHeader('MEALPLAN_UPDATE');
    }
    else if (url.includes('/api/shopping') && method === 'get') setHeader('SHOPPING_VIEW');
    else if (url.includes('/api/shopping') && method === 'put') setHeader('SHOPPING_UPDATE');
    else if (url.includes('/api/orders') && method === 'post') setHeader('DRIVE_ORDER');
    else if (url.includes('/api/users/update-user-list')) setHeader('USER_LIST_UPDATE');
    else if (url.includes('/api/meals/update-recipe')) setHeader('RECIPE_UPDATE');
    else if (url.includes('/api/meals/generate-images')) setHeader('IMAGE_GENERATE');
  } catch (_) {}
  return config;
});

// Intercepteur pour les erreurs
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Gérer les erreurs d'authentification (token expiré, etc.)
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('user');
      
      // Si ce n'est pas une route d'authentification, rediriger vers la page de connexion
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    // Compte suspendu
    if (error.response && error.response.status === 403) {
      const message = error.response.data?.message || '';
      if (message.toLowerCase().includes('compte suspendu')) {
        try { localStorage.removeItem('user'); } catch (_) {}
        try { delete api.defaults.headers.common['Authorization']; } catch (_) {}
        if (!window.location.pathname.includes('/suspended')) {
          window.location.href = '/suspended';
        }
      }
    }
    // Quotas atteints
    if (error.response && error.response.status === 429) {
      const msg = error.response.data?.message || "Quota hebdomadaire atteint";
      try {
        window.dispatchEvent(new CustomEvent('quota:reached', { detail: msg }));
      } catch (_) {}
    }
    
    return Promise.reject(error);
  }
);

export default api;
